export default __webpack_public_path__ + "images/4144e2cf85459895fec68c470257454c.png";